import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { Toaster } from 'sonner';
import App from './App';
import theme from './theme/theme';
import './index.css';
import './assets/css/horizon.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter basename="/">
        <App />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
